export default __webpack_public_path__ + "static/media/lock_close_icon.5874daa7.svg";